import { tabToOfferStateMap } from './tabToOfferStateMap';
import { useOfferPaginationTotals } from './useOfferPaginationTotals';

export const useOfferOverviewTotals = ({ searchQuery, supplierIds, customerIds }) => {
    return useOfferPaginationTotals({
        searchQuery,
        supplierIds,
        customerIds,
        offerTabs: ['enquired', 'ordered', 'acknowledged', 'confirmed', 'delivered', 'canceled', 'expired'],
        tapToOfferStateMap: tabToOfferStateMap,
    });
};
